import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Download, Gamepad2, Gift } from "lucide-react";

const steps = [
  {
    icon: <Download className="h-12 w-12 text-primary" />,
    title: "App herunterladen",
    description: "Lade die Rewards App kostenlos auf dein iOS-Gerät herunter."
  },
  {
    icon: <Gamepad2 className="h-12 w-12 text-primary" />,
    title: "Spiele spielen",
    description: "Spiele das erste Spiel und entdecke weitere spannende Spiele in der App."
  },
  {
    icon: <Gift className="h-12 w-12 text-primary" />,
    title: "Belohnungen erhalten",
    description: "Sammle Punkte und tausche sie gegen exklusive Belohnungen ein."
  }
];

const HowItWorksSection = () => {
  const handleDownload = () => {
    window.open("https://singingfiles.com/show.php?l=0&u=2392393&id=69074", "_blank");
  };

  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-b from-background to-secondary/20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              So einfach geht's
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              In nur wenigen Schritten kannst du loslegen und Belohnungen sammeln
            </p>
          </motion.div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="bg-card rounded-lg p-8 border border-border relative z-10 h-full">
                <div className="mb-6 bg-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-center text-foreground">{step.title}</h3>
                <p className="text-muted-foreground text-center">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 z-0">
                  <div className="w-12 h-1 bg-primary/30 rounded"></div>
                </div>
              )}
            </motion.div>
          ))}
        </div>
        
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <Button 
            size="lg" 
            className="bg-primary hover:bg-primary/90 text-primary-foreground px-8"
            onClick={handleDownload}
          >
            Jetzt herunterladen
            <Download className="ml-2 h-4 w-4" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;